import { render } from "./AdLeadRequest.vue?vue&type=template&id=548fc3e8"
import script from "./AdLeadRequest.vue?vue&type=script&lang=js"
export * from "./AdLeadRequest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__